/**
 * @format
 */
export const TOGGLE_CE_TEMP_LOADING = 'toggle_ce_temp_loading';
